import { useCallback, useEffect, useState } from "react";

import { useNavigate, useSearchParams } from "react-router-dom";

import { toast, ToastContainer } from "react-toastify";

import LeftChevron from "../../../../assets/images/chevron-left-color.svg";

import ProgressBar from "../../../../shared/LinearProgressBar";

import Button from "../ButtonComponent";

import HeaderModule from "../ModuleHeaderComponent";
import ModuleStatusComponent from "../ModuleStatusComponent";

import QuestionCards from "../QuestionCards";

import Shimmer from "../ShimmerComponent";

import { useSavePostCourseAssessment } from "./mutation";

import { BUTTON_VARIANTS } from "../constant";

import { useGetPostAssessmentQuestion } from "./queries";

import styles from "./styles.module.scss";
import AssessmentExitModal from "../AssessmentExitModal";
// import CertificateCourseCompleteModal from "../CertificateCourseComplete";
import { COURSE_MARKS } from "../../../../utils/cookiesmanager";

const PostCourseAssessment = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [animate, setAnimate] = useState(false);
  const [selectedAnswer, setSelectedAnswer] = useState({});
  const [isFinished, setIsFinished] = useState(false);
  const [questionResponse, setQuestionResponse] = useState({});
  const [allowLeave, setAllowLeave] = useState(false);
  const [showWarning, setShowWarning] = useState(false);
  // const [showCertificateModal , setShowCertificateModal] = useState(false);

  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const courseId = searchParams.get("courseId");
  const courseName = searchParams.get("courseName");
  const moduleId = searchParams.get("moduleId");

  const languageId = localStorage.getItem("l_id") || 1;

  const { data: postAssessmentQuestion, isLoading } =
    useGetPostAssessmentQuestion({
      courseId,
      languageId,
    });

  const { mutate } = useSavePostCourseAssessment();

  const { data: postAssessmentQuestionData } = postAssessmentQuestion || {};

  const { response } = postAssessmentQuestionData || {};

  const handleSubmit = () => {
    const currentQuestion = response?.[activeIndex];

    if (!selectedAnswer[currentQuestion?.assQuestionId]) {
      toast.error("Please select an answer");
      return;
    }

    if (activeIndex === response?.length - 1) {
      const payload = {
        courseId: courseId,
        questionArray: Object.entries(selectedAnswer).map(
          ([assQuestionID, answerData]) => ({
            assQuestionID: String(assQuestionID),
            assAnswerID: String(answerData.assessmentAnswerId),
          }),
        ),
      };

      setIsFinished(true);

      mutate(payload, {
        onSuccess(data) {
          const { status, error } = data;

          setQuestionResponse(data?.data?.response);

          localStorage.setItem(COURSE_MARKS,data?.data?.response?.percentage)

          if (!status) {
            throw new Error(error);
          }
          setIsFinished(true);
        },
        onError(error) {
          const errorMessage =
            error instanceof Error ? error.message : String(error);
          toast(errorMessage, { type: "error" });
        },
        onSettled() {},
      });
      return;
    }

    setAnimate(true);
    setTimeout(() => {
      setAnimate(false);
      setActiveIndex((prev) => prev + 1);
    }, 400);
  };

  const handleContinue = () => {
    setIsFinished(false);
    navigate(`/user/post-course-feedback?courseId=${courseId}`);
  };

  const handleTryAgain = () => {
    navigate(`/user/module-list?courseId=${courseId}&courseName=${courseName}`);
  };

  const handlePreviousClick = () => {
    if (activeIndex === 0) return;

    setAnimate(true);

    setTimeout(() => {
      setAnimate(false);
      setActiveIndex((prev) => prev - 1);
    }, 500);
  };

  const handleQuestionAnswer = useCallback((question, option) => {
    setSelectedAnswer((prev) => ({
      ...prev,
      [question?.assQuestionId]: {
        courseId: courseId,
        languageId: 1,
        assessmentId: question?.assessmentId,
        assessmentQuestionId: question?.assQuestionId,
        assessmentAnswerId: option?.assAnswerId,
      },
    }));
  }, []);

  const handleBack = () => {
    setShowWarning(true);
  };

  const handleContinueAssessment = () => {
    setShowWarning(false);
    setAllowLeave(false);
  };

  const handleExit = () => {
    navigate(
      `/user/module-list?courseId=${courseId}&courseName=${courseName}`,
    );
  };

  useEffect(() => {
            // Add a dummy history entry
      window.history.pushState({ guard: true }, "", `${window.location.pathname}?${searchParams.toString()}`);
        
        const handlePopState = () => {
              if (!allowLeave) {
                setShowWarning(true);
        
                // Re-push state to stop navigation
                window.history.pushState(
                  { guard: true },
                  "",
                  window.location.pathname
                );
              }
            };
        
            window.addEventListener("popstate", handlePopState);
        
        return () => {
              window.removeEventListener("popstate", handlePopState);
        };
    },[allowLeave])

  const isFirstQuestion = activeIndex === 0;
  const isLastQuestion = response && activeIndex === response?.length - 1;

  const currentQuestionId = response?.[activeIndex]?.assQuestionId;

  const isOptionSelected = Boolean(selectedAnswer[currentQuestionId]);

  return (
    <>
      <div className={styles.page}>
        <HeaderModule
          title="Post-Course Assessment"
          className={styles["header-title"]}
          onBackClick={handleBack}
        />
        <div className={styles["container-wrapper"]}>
          <div className={styles["content-part"]}>
            <p className={styles.title}>Learning Difficulties</p>
            <ProgressBar current={activeIndex} total={response?.length} />
            {isLoading ? (
              <Shimmer width="90%" height="324px" borderRadius="14px" />
            ) : (
              <QuestionCards
                selectedAnswer={selectedAnswer[currentQuestionId]}
                questionsList={response}
                handleQuestionAnswer={handleQuestionAnswer}
                activeIndex={activeIndex}
                animate={animate}
              />
            )}
          </div>
        </div>
        <div className={styles["bottom-wrapper"]}>
          <Button
            label="Previous"
            buttonVariant={BUTTON_VARIANTS.SECONDARY}
            startIcon={<img src={LeftChevron} alt="previous" />}
            className={styles["button-class"]}
            onClick={handlePreviousClick}
            disabled={isFirstQuestion}
          />
          <Button
            label={isLastQuestion ? "Submit" : "Next"}
            buttonVariant={BUTTON_VARIANTS.PRIMARY}
            className={styles["button-class"]}
            onClick={handleSubmit}
            disabled={!isOptionSelected}
          />
        </div>
        <ToastContainer />
      </div>
      {isFinished && (
        <ModuleStatusComponent
          marks={questionResponse}
          show={isFinished}
          handleContinue={handleContinue}
          handleTryAgain={handleTryAgain}
          passingMarks={60}
        />
      )}
      {showWarning && <AssessmentExitModal handleContinueAssessment={handleContinueAssessment} handleExit={handleExit} show={showWarning} />}
    </>
  );
};

export default PostCourseAssessment;
